// extracted by mini-css-extract-plugin
export default {"main":"Main_main__QhrKC","mainContainer":"Main_mainContainer__9udr1","matrixContainer":"Main_matrixContainer__s8Kl5"};